import '../assets/stylesheets/_custom_bootstrap.scss'

window.jQuery = require('jquery')
require('../vendor/jquery-ui/jquery-ui.min.js')
window.jQuery.noConflict()
window.popper = require('popper.js')
window._ = require('bootstrap')
